import React from 'react';
import { useTranslation } from 'react-i18next';
const NoWhiteboardError = ({ className }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: className }, t('info.noWhiteboard')));
};
export default NoWhiteboardError;
